import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import './LoginPage.css';

const LoginPage = ({ setCurrentPage }) => {
  useEffect(() => {
    const pathname = window.location.pathname;
    
    // Check if redirected from login error
    if (pathname.includes('/loginerror')) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Tutor Login',
        text: 'You are not a valid user. If error persists please contact admin.',
        confirmButtonColor: '#9b59b6',
        confirmButtonText: 'Go Back to Login',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        // Clean URL and stay on login page
        window.history.pushState({}, document.title, '/');
      });
      return;
    }

    const fromHome = sessionStorage.getItem('unauthorizedHome');
    if (fromHome === 'true') {
      Swal.fire('Access Denied', 'Please log in first.', 'error');
      sessionStorage.removeItem('unauthorizedHome');
    }

    const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      // Clean URL to just localhost:3000
      window.history.pushState({}, document.title, '/');
      setCurrentPage('home');
    }
  }, [setCurrentPage]);

  const handleGoogleLogin = (googleUser) => {
    window.location.href = 'https://api2.brainstermath.com/solutions/login_english';
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <h2 className="welcome-text">Welcome to</h2>
        <h1 className="brand-title">Brainster English</h1>
        <img src="/brainster.png" alt="Brain" className="brain-img" />
      </div>

      <div className="login-right">
        <h2 className="login-title">Login</h2>
        <p className="login-subtitle">Sign in with your Google account.</p>
        <div className="login-form">
          <button 
            className="google-login-btn" 
            onClick={() => {
              handleGoogleLogin();
            }}
          >
            <img src="/images/google.svg" alt="Google" className="google-icon" />
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
